import Cookies from "js-cookie";
 
const baseUrl = process.env.REACT_APP_API + "/api";
 
export const CHECKLIST_EXECUTION_URL = baseUrl + "/checklist-executions";
export const CHECKLIST_BUILDER_URL   = baseUrl + "/checklist-builder";
export const CHECKLIST_BINDING_URL   = baseUrl + "/checklist-binding";